import api from "./api";

const getAll = async () => {
    return []
    // const client = await api('notificacao');
    // const { data, status } = await client.get('notificacoes');
    // return status === 404 ? [] : data ? data : [];

}

const updateRead = async (id) => {
    const client = await api('notificacao');
    const { data } = await client.post(`notificacoes/${id}`);
    return data ? data : false;
}

export {
    getAll,
    updateRead,
};
